import React from 'react';

import { ScrollView, StyleSheet } from 'react-native';

import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

import { DeliveryTermsCanada } from './DeliveryTermsCanada';
import { DeliveryTermsUS } from './DeliveryTermsUS';

export const DeliveryTermsContent = () => {
  const isCanada = region === Region.CA;

  return (
    <ScrollView contentContainerStyle={styles.container}>
      {isCanada ? <DeliveryTermsCanada /> : <DeliveryTermsUS />}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    paddingBottom: 32,
  },
});
